(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7900],{

/***/ 58470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspirations",
      function () {
        return __webpack_require__(32914);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ PostsTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/richtext/dist/asText.js
var asText = __webpack_require__(98268);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  text-align: center;\n  transition: 0.3s;\n  min-height: 100%;\n  padding: 1rem;\n  &:hover {\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);\n    // background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  position: relative;\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  text-align: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  margin-top: 7px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n  margin-top: 7px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.colors.redLight;
}, function(props) {
    return props.theme.colors.white;
});
var Image = globalStyles/* styled.div */.zo.div(_templateObject1(), function(param) {
    var square = param.square;
    return square ? "100%" : undefined;
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject2(), function(param) {
    var align = param.align;
    return align;
});
var Title = globalStyles/* styled.h3 */.zo.h3(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.red;
});
var Text = globalStyles/* styled.p */.zo.p(_templateObject4(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
});
var Tags = globalStyles/* styled.p */.zo.p(_templateObject5(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/PostsTile.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 




var PostsTile = function(param) {
    var key = param.key, link = param.link, image = param.image, title = param.title, text = param.text, tags = param.tags, _align = param.align, align = _align === void 0 ? "center" : _align, _square = param.square, square = _square === void 0 ? true : _square;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        square: square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: image,
                            height: 320,
                            sizes: "(max-width: 540px) 66vw, (max-width: 1279px) 50vw, 20vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        align: align,
                        children: [
                            title && typeof title !== "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: asText/* asText */.S(title)
                            }),
                            title && typeof title === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: asText/* asText */.S(text)
                            }),
                            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                children: tags.join(", ")
                            })
                        ]
                    })
                ]
            })
        })
    }, key);
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/index.ts



/***/ }),

/***/ 96985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ TagsFilter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/images/cross-x.svg
var cross_x_namespaceObject = __webpack_require__.p + "static/images/cross-x.svg";
;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin: 5.5px 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 36px;\n    padding-bottom: 4px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 2px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 8px;\n      height: 8px\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 46px;\n  font-size: ",
        ";\n  line-height: 100%;\n  border-radius: 23px;\n  box-shadow: inset 0px 0px 0px 2px #eaeaea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px 6px;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n  ::after {\n    margin-left: 6px;\n    content: '';\n    display: none;\n    width: 14px;\n    height: 14px;\n    background: url(",
        ");\n    background-size: contain;\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    ",
        ":hover & {\n      ",
        " {\n        background: #f9edec;\n        box-shadow: none;\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    ",
        " {\n      background: #c34c3e;\n      box-shadow: none;\n      color: #ffffff;\n      ::after {\n        display: block;\n      }\n    }\n\n    &:hover {\n      ",
        " {\n        background: #c9c9c9;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var TagCheckbox = globalStyles/* styled.div */.zo.div(_templateObject());
var LabelInner = globalStyles/* styled.span */.zo.span(_templateObject4(), function(props) {
    return props.theme.typography.h5FontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), cross_x_namespaceObject, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()));
var Label = globalStyles/* styled.label */.zo.label(_templateObject5(), TagCheckbox, LabelInner, LabelInner, LabelInner, function(props) {
    return props.theme.colors.baseFont;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/TagCheckbox.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 






var ENTER_KEY = 13;
var SPACE_KEY = 32;
var TagCheckbox_TagCheckbox = function(_param) {
    var name = _param.name, checked = _param.checked, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "value",
        "onChange"
    ]);
    var ref = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCheckbox, {
        ref: ref,
        onClick: function(evt) {
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    tabIndex: -1,
                    type: "checkbox",
                    name: name,
                    checked: checked,
                    readOnly: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref,
                    tabIndex: 0,
                    onKeyDown: function(evt) {
                        if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                            evt.preventDefault();
                            onChange(evt);
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelInner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (0,translations/* translate */.I)(value, "name").replace("_", " ")
                        })
                    })
                })
            ]
        })
    });
};
TagCheckbox_TagCheckbox.displayName = "TagCheckbox";

;// CONCATENATED MODULE: ./src/@next/components/atoms/TagCheckbox/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin: -5.5px -3px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject());

;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/TagsFilter.tsx




var TagsFilter = function(param) {
    var name = param.name, values = param.values, onValueClick = param.onValueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: values && values.map(function(value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCheckbox_TagCheckbox, {
                name: name,
                checked: !!value.selected,
                onChange: function() {
                    return onValueClick(value);
                },
                value: value
            }, value.id);
        })
    });
};
TagsFilter.displayName = "TagsFilter";

;// CONCATENATED MODULE: ./src/@next/components/molecules/TagsFilter/index.ts



/***/ }),

/***/ 44610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rv": function() { return /* binding */ paddingLeft; },
  "tj": function() { return /* binding */ pageTitle; },
  "C7": function() { return /* binding */ prismicRichText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/title-top.svg
var title_top = __webpack_require__(43157);
;// CONCATENATED MODULE: ./src/images/title-top-blue.svg
var title_top_blue_namespaceObject = __webpack_require__.p + "static/images/title-top-blue.svg";
// EXTERNAL MODULE: ./src/@next/globalStyles/media.ts
var media = __webpack_require__(59390);
;// CONCATENATED MODULE: ./src/@next/globalStyles/utils.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 25px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 64px;\n        left: -25px;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 35px;\n        left: -15px;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px 0 0;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 0 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 1em;\n    font-weight: lighter;\n    color: ",
        ";\n    letter-spacing: -0.5px;\n    padding: 40px 0 0;\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: -44px;\n      top: 0;\n      width: 92px;\n      height: 15px;\n      background: url(",
        ") no-repeat left top;\n      background-size: contain;\n      ",
        "\n      ",
        "\n    }\n    &.blue {\n      &:before {\n        background: url(",
        ") no-repeat left top;\n        background-size: contain;\n      }\n    }\n    ",
        "\n    ",
        "\n    * {\n      font: inherit;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 15px;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 12px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 110%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  h5,\n  h6 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 140%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    line-height: 180%;\n    margin-bottom: ",
        ";\n  }\n\n  a {\n    text-decoration: underline;\n    color: ",
        ";\n  }\n\n  b {\n    font-weight: 600;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n\n  & em {\n    color: ",
        ";\n  }\n\n  ul,\n  ol {\n    margin-bottom: ",
        ";\n\n    li {\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: 220%;\n      color: ",
        "; // #666f73;\n    }\n  }\n\n  ul {\n    li {\n      padding-left: 24px;\n      position: relative;\n\n      &:before {\n        content: '';\n        display: block;\n        background-color: ",
        ";\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        position: absolute;\n        left: 0;\n        top: 17px;\n\n        ",
        "\n        ",
        "\n      }\n    }\n  }\n\n  ol {\n    list-style: inside;\n    list-style-type: decimal;\n  }\n\n  &.text-center * {\n    text-align: center;\n  }\n\n  &.text-right * {\n    text-align: right;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var paddingLeft = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
    var theme = param.theme;
    return "".concat(theme.container.paddingLeft, "px");
}, media/* media.mediumScreen */.B.mediumScreen(_templateObject()), media/* media.smallScreen */.B.smallScreen(_templateObject1()));
var pageTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), function(props) {
        return props.theme.typography.h2FontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, theme.colors.baseFont, title_top, media/* media.largeScreen */.B.largeScreen(_templateObject3()), media/* media.smallScreen */.B.smallScreen(_templateObject4()), title_top_blue_namespaceObject, media/* media.largeScreen */.B.largeScreen(_templateObject5()), media/* media.smallScreen */.B.smallScreen(_templateObject6()));
});
var prismicRichText = (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.colors.blueLight;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.colors.red;
}, media/* media.largeScreen */.B.largeScreen(_templateObject9()), media/* media.smallScreen */.B.smallScreen(_templateObject10()));


/***/ }),

/***/ 86534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SS": function() { return /* reexport */ queryTypes; },
  "v1": function() { return /* reexport */ useQueryState; },
  "XI": function() { return /* reexport */ useQueryStates; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/defs.ts


var queryTypes = {
    string: {
        parse: function(v) {
            return v;
        },
        serialize: function(v) {
            return "".concat(v);
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    integer: {
        parse: function(v) {
            return parseInt(v, 10);
        },
        serialize: function(v) {
            return Math.round(v).toFixed();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    float: {
        parse: function(v) {
            return parseFloat(v);
        },
        serialize: function(v) {
            return v.toString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    boolean: {
        parse: function(v) {
            return v === "true";
        },
        serialize: function(v) {
            return v ? "true" : "false";
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    timestamp: {
        parse: function(v) {
            return new Date(parseInt(v, 10));
        },
        serialize: function(v) {
            return v.valueOf().toString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    isoDateTime: {
        parse: function(v) {
            return new Date(v);
        },
        serialize: function(v) {
            return v.toISOString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    stringEnum: function stringEnum(validValues) {
        return {
            parse: function(query) {
                var asEnum = query;
                if (validValues.includes(asEnum)) {
                    return asEnum;
                }
                return null;
            },
            serialize: function(value) {
                return value.toString();
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    },
    json: function json() {
        return {
            parse: function(query) {
                try {
                    return JSON.parse(decodeURIComponent(query));
                } catch (e) {
                    return null;
                }
            },
            serialize: function(value) {
                return encodeURIComponent(JSON.stringify(value));
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    },
    array: function array(itemSerializers) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
        return {
            parse: function(query) {
                return query.split(separator).map(function(item) {
                    return decodeURIComponent(item);
                }).map(itemSerializers.parse).filter(function(value) {
                    return value !== null && value !== undefined;
                });
            },
            serialize: function(values) {
                return values.map(function(value) {
                    if (itemSerializers.serialize) {
                        return itemSerializers.serialize(value);
                    }
                    return "".concat(value);
                }).map(encodeURIComponent).join(separator);
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    }
};

// EXTERNAL MODULE: ./node_modules/next-translate-routes/router.js
var next_translate_routes_router = __webpack_require__(56827);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/useQueryState.ts


/**
 * React state hook synchronized with a URL query string in Next.js
 *
 * If used without a `defaultValue` supplied in the options, and the query is
 * missing in the URL, the state will be `null`.
 *
 * ### Behaviour with default values:
 *
 * _Note: the URL will **not** be updated with the default value if the query
 * is missing._
 *
 * Setting the value to `null` will clear the query in the URL, and return
 * the default value as state.
 *
 * Example usage:
 * ```ts
 *   // Blog posts filtering by tag
 *   const [tag, selectTag] = useQueryState('tag')
 *   const filteredPosts = posts.filter(post => tag ? post.tag === tag : true)
 *   const clearTag = () => selectTag(null)
 *
 *   // With default values
 *
 *   const [count, setCount] = useQueryState(
 *     'count',
 *     queryTypes.integer.defaultValue(0)
 *   )
 *
 *   const increment = () => setCount(oldCount => oldCount + 1)
 *   const decrement = () => setCount(oldCount => oldCount - 1)
 *   const clearCountQuery = () => setCount(null)
 *
 *   // --
 *
 *   const [date, setDate] = useQueryState(
 *     'date',
 *     queryTypes.isoDateTime.withDefault(new Date('2021-01-01'))
 *   )
 *
 *   const setToNow = () => setDate(new Date())
 *   const addOneHour = () => {
 *     setDate(oldDate => new Date(oldDate.valueOf() + 3600_000))
 *   }
 * ```
 * @param key The URL query string key to bind to
 * @param options - Serializers (defines the state data type), optional default value and history mode.
 */ function useQueryState(key) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        history: "replace",
        parse: function(x) {
            return x;
        },
        serialize: String,
        defaultValue: undefined
    }, _history = ref.history, history = _history === void 0 ? "replace" : _history, _parse = ref.parse, parse = _parse === void 0 ? function(x) {
        return x;
    } : _parse, _serialize = ref.serialize, serialize = _serialize === void 0 ? String : _serialize, _defaultValue = ref.defaultValue, defaultValue = _defaultValue === void 0 ? undefined : _defaultValue;
    var router = (0,next_translate_routes_router.useRouter)();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    var updateUrl = react.useMemo(function() {
        return history === "push" ? router.push : router.replace;
    }, [
        history
    ]);
    var getValue = react.useCallback(function() {
        if (false) {}
        var query = new URLSearchParams(window.location.search);
        var value = query.get(key);
        return value !== null ? parse(value) : null;
    }, []);
    // Update the state value only when the relevant key changes.
    // Because we're not calling getValue in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    var value = react.useMemo(getValue, [
        router.query[key]
    ]);
    var update = react.useCallback(function(stateUpdater, transitionOptions) {
        var isUpdaterFunction = function(input) {
            return typeof input === "function";
        };
        var ref, ref1;
        // Resolve the new value based on old value & updater
        var oldValue = (ref1 = (ref = getValue()) !== null && ref !== void 0 ? ref : defaultValue) !== null && ref1 !== void 0 ? ref1 : null;
        var newValue = isUpdaterFunction(stateUpdater) ? stateUpdater(oldValue) : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        var query = new URLSearchParams(window.location.search);
        if (newValue === null) {
            // Don't leave value-less keys hanging
            query.delete(key);
        } else {
            query.set(key, serialize(newValue));
        }
        var search = query.toString();
        var hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, transitionOptions);
    }, [
        key,
        updateUrl
    ]);
    var ref1;
    return [
        (ref1 = value !== null && value !== void 0 ? value : defaultValue) !== null && ref1 !== void 0 ? ref1 : null,
        update
    ];
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/useQueryStates.ts





/**
 * Synchronise multiple query string arguments to React state in Next.js
 *
 * @param keys - An object describing the keys to synchronise and how to
 *               serialise and parse them.
 *               Use `queryTypes.(string|integer|float)` for quick shorthands.
 */ function useQueryStates(keys) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _history = ref.history, history = _history === void 0 ? "replace" : _history;
    var router = (0,next_translate_routes_router.useRouter)();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    var updateUrl = react.useMemo(function() {
        return history === "push" ? router.push : router.replace;
    }, [
        history
    ]);
    var getValues = react.useCallback(function() {
        if (false) {}
        var query = new URLSearchParams(window.location.search);
        return Object.keys(keys).reduce(function(values, key) {
            var _key = keys[key], parse = _key.parse, defaultValue = _key.defaultValue;
            var value = query.get(key);
            var ref, ref1;
            var parsed = value !== null ? (ref1 = (ref = parse(value)) !== null && ref !== void 0 ? ref : defaultValue) !== null && ref1 !== void 0 ? ref1 : null : defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, key, parsed));
        }, {});
    }, [
        keys
    ]);
    // Update the state values only when the relevant keys change.
    // Because we're not calling getValues in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    var values = react.useMemo(getValues, Object.keys(keys).map(function(key) {
        return router.query[key];
    }));
    var update = react.useCallback(function(stateUpdater, transitionOptions) {
        var isUpdaterFunction = function(input) {
            return typeof input === "function";
        };
        // Resolve the new values based on old values & updater
        var oldValues = getValues();
        var newValues = isUpdaterFunction(stateUpdater) ? stateUpdater(oldValues) : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        var query = new URLSearchParams(window.location.search);
        Object.keys(newValues).forEach(function(key) {
            var newValue = newValues[key];
            if (newValue === null) {
                query.delete(key);
            } else if (newValue !== undefined) {
                var _key = keys[key], _serialize = _key.serialize, serialize = _serialize === void 0 ? String : _serialize;
                query.set(key, serialize(newValue));
            }
        });
        var search = query.toString();
        var hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, transitionOptions);
    }, [
        keys,
        updateUrl
    ]);
    return [
        values,
        update
    ];
}

;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/index.ts





/***/ }),

/***/ 32243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PrismicNextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/helpers/isFilled.js
var isFilled = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildURL.ts
/**
 * Converts a camel case string to a param case string.
 *
 * @example
 *
 * ```ts
 * camelCaseToParamCase("fooBar");
 * // => 'foo-bar'
 * ```
 *
 * @param input - Camel case string to convert.
 *
 * @returns Param case version of `input`.
 */ var camelCaseToParamCase = function(input) {
    return input.replace(/[A-Z]/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
};
/**
 * Builds a URL to an Imgix image with Imgix URL API parameters.
 *
 * The given URL must be a full absolute URL containing the protocol and domain.
 *
 * URL parameters already applied to the image will be retained. To remove
 * existing parameters, set the parameter to `undefined` in the `params` argument.
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png", {
 * 	width: 400,
 * });
 * // => https://example.imgix.net/image.png?width=400
 * ```
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png?width=400", {
 * 	height: 300,
 * });
 * // => https://example.imgix.net/image.png?width=400&height=300
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters.
 *
 * @returns `url` with the given Imgix URL API parameters applied.
 *
 * @see Imgix URL API reference: https://docs.imgix.com/apis/rendering
 */ var buildURL = function(url, params) {
    var instance = new URL(url);
    Object.keys(params).forEach(function(camelCasedParamKey) {
        var paramKey = camelCaseToParamCase(camelCasedParamKey);
        var paramValue = params[camelCasedParamKey];
        if (paramValue === undefined) {
            instance.searchParams.delete(paramKey);
        } else if (Array.isArray(paramValue)) {
            instance.searchParams.set(paramKey, paramValue.join(","));
        } else {
            instance.searchParams.set(paramKey, "".concat(paramValue));
        }
    });
    // Ensure the `s` parameter is the last parameter, if it exists.
    // @see https://github.com/imgix/imgix-blueprint#securing-urls
    var s = instance.searchParams.get("s");
    if (s) {
        instance.searchParams.delete("s");
        instance.searchParams.append("s", s);
    }
    return instance.toString();
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildWidthSrcSet.ts




/**
 * Builds an `<img>` `srcset` attribute value for a given set of widths. It can
 * also optinally apply Imgix URL API parameters to the URLs.
 *
 * The `width` URL parameter will be applied for each `srcset` entry. If a
 * `width` or `w` parameter is provided to the `params` parameter, it will be ignored.
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * });
 * // => https://example.imgix.net/image.png?width=400 400w,
 * //    https://example.imgix.net/image.png?width=800 800w,
 * //    https://example.imgix.net/image.png?width=1600 1600w
 * ```
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * 	sat: -100,
 * });
 * // => https://example.imgix.net/image.png?width=400&sat=-100 400w,
 * //    https://example.imgix.net/image.png?width=800&sat=-100 800w,
 * //    https://example.imgix.net/image.png?width=1600&sat=-100 1600w
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters. The `widths` parameter
 *   defines the resulting `srcset` widths.
 *
 * @returns A `srcset` attribute value for `url` with the given Imgix URL API
 *   parameters applied.
 */ var buildWidthSrcSet = function(url, _param) {
    var widths = _param.widths, params = (0,_object_without_properties/* default */.Z)(_param, [
        "widths"
    ]);
    return widths.map(function(width) {
        return "".concat(buildURL(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
            w: undefined,
            width: width
        })), " ").concat(width, "w");
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/PrismicNextImage.tsx
/* eslint-disable */ 







var castInt = function(input) {
    if (typeof input === "number" || typeof input === "undefined") {
        return input;
    }
    var parsed = Number.parseInt(input, 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return parsed;
};
/**
 * Creates a `next/image` loader for Imgix, which Prismic uses, with an optional
 * collection of default Imgix parameters.
 *
 * @see To learn about `next/image` loaders: https://nextjs.org/docs/api-reference/next/image#loader
 * @see To learn about Imgix's URL API: https://docs.imgix.com/apis/rendering
 */ var imgixLoader = function(args) {
    var url = new URL(args.src);
    var params = {
        auto: url.searchParams.getAll("auto") || [
            "format", 
        ],
        fit: url.searchParams.get("fit") || "max",
        w: args.width,
        h: undefined
    };
    if (args.quality) {
        params.q = args.quality;
    }
    return buildURL(args.src, params);
};
/**
 * React component that renders an image from a Prismic Image field or one of
 * its thumbnails using `next/image`. It will automatically set the `alt`
 * attribute using the Image field's `alt` property.
 *
 * It uses an Imgix URL-based loader by default. A custom loader can be provided
 * with the `loader` prop. If you would like to use the Next.js Image
 * Optimization API instead, set `loader={undefined}`.
 *
 * @param props - Props for the component.
 *
 * @returns A responsive image component using `next/image` for the given Image
 *   field.
 * @see To learn more about `next/image`, see: https://nextjs.org/docs/api-reference/next/image
 */ var PrismicNextImage = function(_param) {
    var field = _param.field, _imgixParams = _param.imgixParams, imgixParams = _imgixParams === void 0 ? {} : _imgixParams, alt = _param.alt, fallbackAlt = _param.fallbackAlt, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "imgixParams",
        "alt",
        "fallbackAlt"
    ]);
    if (typeof alt === "string" && alt !== "") {
        console.warn('[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="".');
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
        console.warn('[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="".');
    }
    if (isFilled/* imageThumbnail */.S$(field)) {
        var src = buildURL(field.url, imgixParams);
        var url = new URL(src);
        var mediaUrl = new URL("https://images.renodoors.eu/");
        url.hostname = mediaUrl.hostname;
        var ar = field.dimensions.width / field.dimensions.height;
        var resolvedWidth = field.dimensions.width;
        var resolvedHeight = field.dimensions.height;
        if ("width" in restProps || "height" in restProps) {
            var castedWidth = castInt(restProps.width);
            var castedHeight = castInt(restProps.height);
            if (castedWidth) {
                resolvedWidth = castedWidth;
            } else if (castedHeight) {
                resolvedWidth = ar * castedHeight;
            }
            resolvedHeight = resolvedWidth / ar;
        }
        var mobileSrcSet = field["mobile"] ? buildWidthSrcSet(field["mobile"].url, {
            widths: [
                constants/* smallScreen */.xC,
                2 * constants/* smallScreen */.xC
            ]
        }) : null;
        var tabletSrcSet = field["tablet"] ? buildWidthSrcSet(field["tablet"].url, {
            widths: [
                constants/* mediumScreen */.M7,
                2 * constants/* mediumScreen */.M7
            ]
        }) : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            children: [
                mobileSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* smallScreen */.xC, "px)"),
                    srcSet: mobileSrcSet
                }),
                tabletSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* mediumScreen */.M7, "px)"),
                    srcSet: tabletSrcSet
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                    src: url.href,
                    width: resolvedWidth,
                    height: resolvedHeight,
                    alt: alt !== null && alt !== void 0 ? alt : field.alt || fallbackAlt,
                    loader: imgixLoader
                }, restProps))
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/index.ts



/***/ }),

/***/ 32914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ inspirations; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/@next/hooks/useQueryState/index.ts + 3 modules
var useQueryState = __webpack_require__(86534);
;// CONCATENATED MODULE: ./src/views/Realization/utils.ts
var parseQueryAttributeFilters = function(query) {
    var filters = {};
    if (query == null || query === "") {
        return filters;
    }
    var propsWithValues = query.split(".").filter(function(n) {
        return n;
    });
    propsWithValues.map(function(value) {
        var propWithValues = value.split("_").filter(function(n) {
            return n;
        });
        filters[propWithValues[0]] = propWithValues.slice(1);
    });
    return filters;
};
var serializeQueryAttributeFilters = function(values) {
    var str = [];
    Object.keys(values).forEach(function(value) {
        str.push("".concat(value, "_").concat(values[value].join("_")));
    });
    return str.join(".");
};
var sortProjectsByCreationDate = function(projectList) {
    return(/* if there is a 'sort order' field, sort such projects in descending order
    if there is a 'creation date, - sort such projects in descending order also
    otherwise list all the rest in any order
  */ projectList.slice().sort(function(a, b) {
        var _node = a.node, A_SO = _node.sort_order, A_CD = _node.creation_date;
        var _node1 = b.node, B_SO = _node1.sort_order, B_CD = _node1.creation_date;
        if (A_SO && B_SO) {
            return A_SO - B_SO;
        }
        if (A_SO && !B_SO) {
            return -1;
        }
        if (!A_SO && B_SO) {
            return 1;
        }
        if (A_CD && B_CD) {
            return new Date(B_CD).getTime() - new Date(A_CD).getTime();
        }
        if (A_CD && !B_CD) {
            return -1;
        }
        if (!B_CD && A_CD) {
            return 1;
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/components/molecules/PostsTile/index.ts + 2 modules
var PostsTile = __webpack_require__(21437);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectList/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-gap: 40px 26px;\n    margin-top: 30px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 1fr;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr;\n    grid-gap: 16px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 60px 40px;\n  margin-top: 40px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 200px;\n      height: 48px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column-start: 1;\n      grid-column-end: none;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.showmore {\n    width: 320px;\n    height: 68px;\n    font-size: ",
        ";\n    margin: auto;\n    margin-bottom: 32px;\n    grid-column-start: 2;\n    grid-column-end: 2;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 80px 0 30px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 70px 0 30px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 40px 0 30px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-bottom: 1px solid #cccccc;\n  margin: 100px 0 40px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var List = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var ShowMoreButtonWrapper = globalStyles/* styled.div */.zo.div(_templateObject4());
var ShowMoreButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject7(), function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject6()));
var BorderDiv = globalStyles/* styled.div */.zo.div(_templateObject11(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject8()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectList/ProjectList.tsx








var ProjectList = function(param) {
    var projects = param.projects, onLoadMore = param.onLoadMore, hasNextPage = param.hasNextPage;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                className: "project-list",
                children: projects && projects.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsTile/* PostsTile */.m, {
                        link: (0,core/* generatePath */.Gn)(paths/* paths.inspirationsPost */.H.inspirationsPost, {
                            slug: item.name
                        }),
                        image: item.image,
                        title: item.title,
                        tags: [
                            item.category
                        ],
                        square: true
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderDiv, {}),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButton, {
                    className: "showmore",
                    onClick: onLoadMore,
                    children: intl.formatMessage(src_intl/* commonMessages.showMore */.i4.showMore)
                })
            })
        ]
    });
};
ProjectList.displayName = "ProjectList";

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectList/index.ts


// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/components/molecules/TagsFilter/index.ts + 6 modules
var TagsFilter = __webpack_require__(96985);
// EXTERNAL MODULE: ./src/images/dropdown-arrow.svg
var dropdown_arrow = __webpack_require__(54543);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectFilter/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 60px;\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 20px;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding-bottom: 26px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-left: 5px;\n  ",
        "\n\n  .filter-reset {\n    display: inline-block;\n    margin-left: auto;\n    ",
        "\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 50px;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 35px;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 17px;\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  font-weight: 300;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: #839098;\n  margin-right: 70px;\n  cursor: pointer;\n  transition-property: color;\n  transition-duration: 0.3s;\n  padding-left: 4px;\n  position: relative;\n  ",
        "\n  ",
        "\n  .dropdown-arrow {\n    display: flex;\n    align-items: center;\n    margin-left: 14px;\n    margin-top: 7px;\n    transition-property: transform;\n    transition-duration: 0.3s;\n    ",
        "\n    > div {\n      display: flex;\n      align-items: center;\n    }\n    path {\n      transition-property: stroke, opacity;\n      transition-duration: 0.3s;\n    }\n  }\n  &.active {\n    color: #c34c3e;\n    .dropdown-arrow {\n      transform: rotateX(180deg);\n      path {\n        stroke: #c34c3e;\n        opacity: 1;\n      }\n    }\n  }\n  &.selected {\n    &::before {\n      content: '';\n      display: inline-block;\n      width: 5px;\n      height: 5px;\n      background-color: #ca9c66;\n      border-radius: 50%;\n      position: absolute;\n      top: 0;\n      left: -4px;\n    }\n  }\n  &.no-margin {\n    margin-right: 0;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 30px;\n      padding-bottom: 10px;\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 24px;\n      padding-bottom: 0;\n    "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 20px;\n      padding-bottom: 15px;\n    "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 24px;\n      padding-bottom: 0;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 21px;\n      padding-bottom: 10px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 40px;\n      padding-bottom: 20px;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 24px;\n      padding-bottom: 0;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 14px;\n      padding-bottom: 10px;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 30px;\n      padding-bottom: 20px;\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 24px;\n      padding-bottom: 0;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.category {\n    padding-top: 34px;\n    padding-bottom: 23px;\n    ",
        "\n    ",
        "\n  }\n  &.color {\n    padding-top: 32px;\n    padding-bottom: 20px;\n    ",
        "\n    ",
        "\n  }\n  &.width {\n    padding-top: 38px;\n    padding-bottom: 15px;\n    max-width: 600px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n  &.tag {\n    padding-top: 20px;\n    padding-bottom: 15px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    margin: 30px auto 0;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: #bdbdbd;\n  cursor: pointer;\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject1(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject()));
var Header = globalStyles/* styled.div */.zo.div(styles_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject3()));
var Item = globalStyles/* styled.div */.zo.div(styles_templateObject8(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject6()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject7()));
var Body = globalStyles/* styled.div */.zo.div(_templateObject19(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject10()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject12()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject13()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject15()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject16()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject17()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject18()));
var ResetButton = globalStyles/* styled.div */.zo.div(_templateObject21(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject20()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectFilter/ProjectFilter.tsx










var ProjectFilter = function(param) {
    var onAttributeFiltersChange = param.onAttributeFiltersChange, clearFilters = param.clearFilters, attributes = param.attributes, filters = param.filters;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(null), filterKey = ref[0], setFilterKey = ref[1];
    var toggleFilter = function(key) {
        var val = key === filterKey ? null : key;
        setFilterKey(val);
    };
    var hasFilters = function() {
        return filters.attributes !== undefined;
    };
    var withSelected = function(slug, attributeSlug) {
        var filterItem = attributes.find(function(z) {
            return z.slug === slug;
        });
        if (filterItem) {
            return filterItem.values.map(function(z) {
                var selected = false;
                if (filters.attributes && attributeSlug in filters.attributes) {
                    selected = filters.attributes[attributeSlug].some(function(filter) {
                        return filter === z.slug;
                    });
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, z), {
                    selected: selected
                });
            });
        }
        return [];
    };
    var hasActiveFilter = function(key) {
        return withSelected(key, key).some(function(z) {
            return z.selected;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "project-filter",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                className: "filter-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        className: "\n              filter-item\n              ".concat(filterKey === "category" ? "active" : "", "\n              ").concat(hasActiveFilter("category") ? "selected" : ""),
                        onClick: function() {
                            return toggleFilter("category");
                        },
                        "aria-hidden": "true",
                        children: [
                            intl.formatMessage(src_intl/* realizationMsg.category */.OV.category),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                className: "dropdown-arrow",
                                src: dropdown_arrow
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        className: "\n              filter-item\n              ".concat(filterKey === "tag" ? "active" : "", "\n              ").concat(hasActiveFilter("tag") ? "selected" : ""),
                        onClick: function() {
                            return toggleFilter("tag");
                        },
                        "aria-hidden": "true",
                        children: [
                            intl.formatMessage(src_intl/* realizationMsg.tags */.OV.tags),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                className: "dropdown-arrow",
                                src: dropdown_arrow
                            })
                        ]
                    }),
                    hasFilters() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetButton, {
                        className: "filter-reset",
                        onClick: clearFilters,
                        "aria-hidden": "true",
                        children: intl.formatMessage(src_intl/* realizationMsg.clear_filter */.OV.clear_filter)
                    })
                ]
            }),
            filterKey && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                className: "filter-body ".concat(filterKey || ""),
                children: [
                    filterKey === "category" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsFilter/* TagsFilter */.E, {
                        name: "category",
                        values: withSelected("category", "category"),
                        onValueClick: function(value) {
                            return onAttributeFiltersChange("category", value.slug);
                        }
                    }),
                    filterKey === "tag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsFilter/* TagsFilter */.E, {
                        name: "tag",
                        values: withSelected("tag", "tag"),
                        onValueClick: function(value) {
                            return onAttributeFiltersChange("tag", value.slug);
                        }
                    })
                ]
            }),
            hasFilters() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetButton, {
                className: "filter-reset",
                onClick: clearFilters,
                "aria-hidden": "true",
                children: intl.formatMessage(src_intl/* realizationMsg.clear_filter */.OV.clear_filter)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProjectFilter/index.tsx


// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/views/Realization/styles.ts

function Realization_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 71px;\n    padding-bottom: 110px;\n  "
    ]);
    Realization_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 42px;\n    padding-bottom: 120px;\n  "
    ]);
    Realization_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 40px;\n    padding-bottom: 90px;\n  "
    ]);
    Realization_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 78px;\n  padding-bottom: 200px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Realization_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Realization_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Realization_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Realization_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Realization_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var styles_Wrapper = globalStyles/* styled.div */.zo.div(Realization_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(Realization_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(Realization_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(Realization_styles_templateObject2()));
var styles_Header = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(Realization_styles_templateObject4(), utils/* paddingLeft */.rv);
var Content = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(Realization_styles_templateObject5());
var Title = globalStyles/* styled.h2 */.zo.h2(Realization_styles_templateObject6(), utils/* pageTitle */.tj);

;// CONCATENATED MODULE: ./src/views/Realization/Page.tsx






var Page = function(param) {
    var attributes = param.attributes, filters = param.filters, projects = param.projects, hasNextPage = param.hasNextPage, clearFilters = param.clearFilters, onAttributeFiltersChange = param.onAttributeFiltersChange, onLoadMore = param.onLoadMore;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        className: "realisation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: intl.formatMessage({
                        defaultMessage: "Inspirations",
                        id: "qf/vV3"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectFilter, {
                        attributes: attributes,
                        filters: filters,
                        clearFilters: clearFilters,
                        onAttributeFiltersChange: onAttributeFiltersChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectList, {
                        projects: projects,
                        onLoadMore: onLoadMore,
                        hasNextPage: hasNextPage
                    })
                ]
            })
        ]
    });
};
Page.displayName = "RealisationPage";
/* harmony default export */ var Realization_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Realization/View.tsx











var View = function(param) {
    var allProjects = param.allProjects, projectFilters = param.projectFilters, seo = param.seo;
    var pageCount = 12;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useQueryState/* useQueryState */.v1)("filters", {
        parse: parseQueryAttributeFilters,
        serialize: serializeQueryAttributeFilters,
        defaultValue: {}
    }), 2), attributeFilters = ref[0], setAttributeFilters = ref[1];
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var filters = {
        attributes: attributeFilters
    };
    var clearFilters = function() {
        setAttributeFilters({});
        setPage(1);
    };
    var onFiltersChange = function(name, value) {
        if (Array.isArray(value)) {
            // handle range of values
            setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, "".concat(name), value)));
            setPage(1);
            return;
        }
        if (value === null) {
            // handle clear filter
            var att = (0,_object_spread/* default */.Z)({}, attributeFilters);
            delete att["".concat(name)];
            setAttributeFilters((0,_object_spread/* default */.Z)({}, att));
            setPage(1);
            return;
        }
        // TODO: fixed eslint error. Check it.
        // if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
        if (attributeFilters && name in attributeFilters) {
            if (attributeFilters[name].includes(value)) {
                if (filters.attributes["".concat(name)].length === 1) {
                    var att1 = (0,_object_spread/* default */.Z)({}, attributeFilters);
                    delete att1["".concat(name)];
                    setAttributeFilters((0,_object_spread/* default */.Z)({}, att1));
                } else {
                    setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, "".concat(name), attributeFilters["".concat(name)].filter(function(item) {
                        return item !== value;
                    }))));
                }
            } else {
                setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, "".concat(name), (0,_to_consumable_array/* default */.Z)(attributeFilters["".concat(name)]).concat([
                    value
                ]))));
            }
        } else {
            setAttributeFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributeFilters), (0,_define_property/* default */.Z)({}, "".concat(name), [
                value
            ])));
        }
        setPage(1);
    };
    var onLoadMore = function() {
        setPage(page + 1);
    };
    var attributes = [
        {
            id: "category",
            name: "category",
            slug: "category",
            values: !projectFilters ? [] : projectFilters.allProjectcategorys.edges.map(function(z) {
                return {
                    id: z.node._meta.id,
                    name: z.node.name,
                    slug: z.node._meta.uid,
                    url: z.node.image.url
                };
            })
        },
        {
            id: "tag",
            name: "tag",
            slug: "tag",
            values: !projectFilters ? [] : projectFilters.allProjecttags.edges.map(function(z) {
                return {
                    id: z.node._meta.id,
                    name: z.node.name,
                    slug: z.node._meta.uid
                };
            })
        }, 
    ];
    var projectsAll = !allProjects ? [] : sortProjectsByCreationDate(allProjects.allProjects.edges).filter(function(z) {
        if (filters.attributes === undefined) {
            return true;
        }
        var checkFilters = function(key, val) {
            if (filters.attributes[key]) {
                return filters.attributes[key].includes(val);
            }
            return true;
        };
        var hasCategory = (z.node.category_list || []).some(function(x) {
            var ref, ref1;
            return checkFilters("category", (ref = x === null || x === void 0 ? void 0 : x.category) === null || ref === void 0 ? void 0 : (ref1 = ref._meta) === null || ref1 === void 0 ? void 0 : ref1.uid);
        });
        var hasTag = z.node.tag_list.some(function(x) {
            return checkFilters("tag", x.tag_item && "_meta" in x.tag_item && x.tag_item._meta.uid);
        });
        return hasCategory && hasTag;
    // return hasCategory && hasColor && hasWidth && hasTag;
    }).map(function(z) {
        return {
            category: (z.node.category_list || []).map(function(x) {
                var ref;
                return (x === null || x === void 0 ? void 0 : (ref = x.category) === null || ref === void 0 ? void 0 : ref.name) || "";
            }).filter(function(x) {
                return Boolean(x);
            }).join(", "),
            id: z.node._meta.id,
            image: z.node.image,
            name: z.node._meta.uid,
            title: z.node.title
        };
    });
    var end = page * pageCount;
    var projects = projectsAll.slice(0, end);
    var hasNextPage = projectsAll.length > end;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Realization_Page, {
                clearFilters: clearFilters,
                attributes: attributes,
                filters: filters,
                projects: projects,
                onAttributeFiltersChange: onFiltersChange,
                hasNextPage: hasNextPage,
                onLoadMore: onLoadMore
            })
        ]
    });
};
View.displayName = "AllTypesView";
/* harmony default export */ var Realization_View = (View);

;// CONCATENATED MODULE: ./src/views/Realization/index.tsx


;// CONCATENATED MODULE: ./src/pages/inspirations/index.ts

var __N_SSG = true;
/* harmony default export */ var inspirations = (Realization_View);


/***/ }),

/***/ 54543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/dropdown-arrow.svg";

/***/ }),

/***/ 43157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/title-top.svg";

/***/ }),

/***/ 66686:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S$": function() { return /* binding */ imageThumbnail; }
/* harmony export */ });
/* unused harmony exports color, contentRelationship, date, embed, geoPoint, group, image, integrationField, integrationFields, keyText, link, linkToMedia, number, richText, select, sliceZone, timestamp, title */
const isNonNullish = (input) => {
  return input != null;
};
const isNonEmptyArray = (input) => {
  return !!input.length;
};
const richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const title = (/* unused pure expression or super */ null && (richText));
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const image = (/* unused pure expression or super */ null && (imageThumbnail));
const link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};
const linkToMedia = (/* unused pure expression or super */ null && (link));
const contentRelationship = (/* unused pure expression or super */ null && (link));
const date = (/* unused pure expression or super */ null && (isNonNullish));
const timestamp = (/* unused pure expression or super */ null && (isNonNullish));
const color = (/* unused pure expression or super */ null && (isNonNullish));
const number = (/* unused pure expression or super */ null && (isNonNullish));
const keyText = (field) => {
  return isNonNullish(keyText) && !!field;
};
const select = (/* unused pure expression or super */ null && (isNonNullish));
const embed = (field) => {
  return isNonNullish(field) && !!field.embed_url;
};
const geoPoint = (field) => {
  return isNonNullish(field) && "longitude" in field;
};
const integrationField = (/* unused pure expression or super */ null && (isNonNullish));
const integrationFields = (/* unused pure expression or super */ null && (integrationField));
const group = (group2) => {
  return isNonNullish(group2) && isNonEmptyArray(group2);
};
const sliceZone = (slices) => {
  return isNonNullish(slices) && isNonEmptyArray(slices);
};

//# sourceMappingURL=isFilled.js.map


/***/ }),

/***/ 98268:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ asText; }
/* harmony export */ });
const asText = (richTextField, separator = " ") => {
  let result = "";
  for (let i = 0; i < richTextField.length; i++) {
    if ("text" in richTextField[i]) {
      result += (result ? separator : "") + richTextField[i].text;
    }
  }
  return result;
};

//# sourceMappingURL=asText.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9774,2888,179], function() { return __webpack_exec__(58470); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);